import * as React from 'react';
import { UserLight } from '../../../models';
import { FilterStore } from '../../../stores';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import './PVASelect.css';

interface PVAMultiSelectProps {
    defaultOptions?: any[];
    options: UserLight[];
    selected: number[];
    onChange: Function;
    FilterStore?: FilterStore;
}

interface PVAMultiSelectState {
    isOpen: boolean;
}

@inject('FilterStore') @observer
export class PVAMultiSelectLight extends React.Component<PVAMultiSelectProps, PVAMultiSelectState> {
    constructor(props: PVAMultiSelectProps) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    @computed get survey() {
        if (this.props.FilterStore && this.props.FilterStore.survey) {
            return this.props.FilterStore.survey;
        }
        return null;
    }

    @computed get surveyVersion() {
        if (this.props.FilterStore && this.props.FilterStore.surveyVersion) {
            return this.props.FilterStore.surveyVersion;
        }
        return null;
    }

    // private PVABadge(user: UserLight, index: number) {
    //     if (!this.survey || !user.styleName || user.styleName === '' || user.resultsArePrivate) {
    //         return <PVABadge key={`pvabadge-${index}`} style={''} badge={''} />;
    //     }

    //     return <PVABadge key={`pvabadge-${index}`} style={user.styleName} badge={user.styleName[0]} />;
    // }

    private userChange(userId: number) {
        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    value: userId
                }
            });

            // if userid is 0 or less, we're going to assume this is some sort of custom entry
            // like "all users" or "clear selected" and we'll trigger an auto close of the drop down
            if (userId <= 0) {
                this.setState({isOpen: false});
            }
        }
        // this.setState({ isOpen: !this.state.isOpen });
    }

    private sortUsers(a: UserLight, b: UserLight): number {
        if (a.lastName > b.lastName) {
            return 1;
        } else if (a.lastName < b.lastName) {
            return -1;
        }
        if (a.firstName > b.firstName) {
            return 1;
        } else if (a.firstName < b.firstName) {
            return -1;
        }

        return 0;
    }

    render() {

        return (
            <div className="pva-select-box multi">
                <div className={`pva-select-box-selected ${this.state.isOpen ? 'open' : ''}`} onClick={(e) => this.setState({ isOpen: !this.state.isOpen })}>
                    <div className="user-row">
                        <span>{this.props.selected.length} Team Members</span>
                    </div>
                    <div className="pva-select-box-toggle">
                        {!this.state.isOpen && <span className="glyphicon glyphicon-triangle-bottom" />}
                        {this.state.isOpen && <span className="glyphicon glyphicon-triangle-top" />}
                    </div>
                </div>
                {this.state.isOpen &&
                    <div className="pva-select-box-options">
                        {this.props.defaultOptions && this.props.defaultOptions.map((data: any, ind: number) => {
                            return <div key={`select-default-opt-${ind}`} className="user-row" onClick={(e) => this.userChange(data.id)}>
                                <div className="user-name"><span>{data.value}</span></div>
                            </div>;
                        })}
                        {this.props.options.sort(this.sortUsers).map((user: UserLight, index: number) => {
                            return <div key={`select-opt-${user.id}`} className="user-row" onClick={(e) => this.userChange(user.id)}>
                                <div className="user-checkbox">
                                    <div className={`pva-checkbox ${this.props.selected.indexOf(user.id) > -1 ? 'checked' : ''}`}>
                                        <div className="checkbox-inner" />
                                    </div>
                                </div>
                                <div className="user-name">
                                    <span>{user.lastName}, {user.firstName}</span>
                                    {user.resultsArePrivate && <span> (Private)</span>}
                                </div>
                                {/* <div className="user-style">{this.PVABadge(user, index)}</div> */}
                            </div>;
                        })}
                    </div>}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVAMultiSelectLight.tsx